import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-aggregate-version-error-dialog',
    templateUrl: './aggregate-version-error-dialog.component.html',
    styleUrls: ['./aggregate-version-error-dialog.component.scss'],
    standalone: false
})
export class AggregateVersionErrorDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<AggregateVersionErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string) {

  }

  ngOnInit(): void {
  }

  static createConfigurations(message: string | undefined = undefined): MatDialogConfig {
    return {
      height: '130px',
      data: message,
      autoFocus: false,
      disableClose: true
    }
  }

}
